import { timeFormat } from 'd3-time-format';

const humanTimeFormat = timeFormat('%c');
const humanMonthFormat = timeFormat('%-m/%-Y');
const s4 = () => Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);

/* Create unique ID's for actions */
export const idCreator = () => `${s4()}${s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;

/* Create descriptive info for actions */
export const descriptionCreator = ({ source, type, params }) => {
  const { startTime, endTime, month } = params || {};
  // TODO: localize
  const startTimeString = startTime ? ` from ${humanTimeFormat(startTime)}` : '';
  const endTimeString = endTime ? ` until ${humanTimeFormat(endTime)}` : '';
  const monthString = month ? ` for ${humanMonthFormat(month)}` : '';

  return `Loading ${
    type ? `${type} ` : ''
  }information from ${
    source
  }${
    monthString
  }${
    startTimeString
  }${
    endTimeString
  }...`;
};

/* The creators used by redux-actions */
export const payloadCreator = ({ data, error }) => (error || data);
export const metaCreator = m => m;
